import { unwrap } from "@brad-tipper/app-frontend";
import { api } from "~/api/client";
import { DELETE_CONFIRMATION } from "./account-deletion";

export type DeletionRequest = { requestedAt: string; scheduledFor: string };

/** The signed-in user's pending deletion request, or null. */
export async function getDeletionRequest(): Promise<DeletionRequest | null> {
  const status = await unwrap(api.getAccountDeletion());
  return status.scheduledFor && status.requestedAt
    ? { requestedAt: status.requestedAt, scheduledFor: status.scheduledFor }
    : null;
}

export async function requestDeletion(
  confirmedEmail: string,
): Promise<DeletionRequest> {
  const status = await unwrap(
    api.requestAccountDeletion({
      body: { confirmation: DELETE_CONFIRMATION, email: confirmedEmail.trim() },
    }),
  );
  return {
    requestedAt: status.requestedAt ?? new Date().toISOString(),
    scheduledFor: status.scheduledFor ?? "",
  };
}

export async function cancelDeletion() {
  await unwrap(api.cancelAccountDeletion());
}

/** Everything the signed-in user owns, as one JSON document. */
export async function exportMyData() {
  return unwrap(api.exportAccount());
}
